/**
 * @author varun
 */
angular.module('App.video.rootscope',['App.video.service','jv.Privacy.Policy.Directive'])
    .run(['$rootScope', 'videoService','formResponseIdService', '$location', '$compile' , '$window', 'browserDetails',
    function($rootScope, videoService, formResponseIdService, $location, $compile, $window, browserDetails){
        if(browserDetails.getBrowser() === 'Microsoft Internet Explorer' && parseInt(browserDetails.getBrowserVersion(),10) <9 ){
            $location.path('/UnreachableInterview/browserUnsupported');
            return;
        }
        var getCompanyDescription = function(cid){
            videoService.getCompanyDescriptionFromJHire({
                'companyEId':cid
            }, function(result){
                $rootScope.summary.company.description = result.companyDescription;
            });
        };

        var massageResult = function(result){
            if(result.company!==null && angular.isDefined(result.company) &&  angular.isDefined(result.company.logo)){
                result.company.logoUrl = result.company.logo;
            }
            // add time in millis so that filter can be applied.
            result.timeMillis = (result.time||0)*1000;
            return result;
        };

        function getSummary(){
            videoService.getSummary(null,function(result){
                if(angular.isDefined(result)){
                    result = massageResult(result);
                }else{
                    //TODO: What should we do if the result is failing? Show some message that we are not able to communicate or network is down or something.
                    return false;
                }
                $rootScope.summary = result;
                $rootScope.privacyPolicyURL = result.privacyPolicyURL;
                if (angular.isDefined(result.candidate)) {
                    $rootScope.summary.firstName = result.candidate.firstName;
                }
                if($rootScope.summary.company!==null && angular.isDefined($rootScope.summary.company) && $rootScope.summary.company.description === null){
                    getCompanyDescription($rootScope.summary.company.EId);
                }
            });
        }

        $rootScope.$watch('interviewId', function(newValue, oldValue){
            // only call if the summary property of the root scope is not set up already.
            if(((angular.isUndefined($rootScope.summary) || (angular.isDefined($rootScope.summary) && $rootScope.summary.company === null)) && angular.isDefined(newValue))){
                getSummary();
            }
        });
    }]);
